import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Input from '../../../../componentLibrary/Input';
import Button from '../../../../componentLibrary/Button';
import HorizontalRule from '../../../../componentLibrary/HorizontalRule';
import InputValidator from '../../../../componentLibrary/InputValidator';
import * as columnItemActions from '../../../../actions/columnItem';
import { setApplicationFocus } from '../../../../actions/browser';
import APPLICATION_FOCUS from '../../../../constants/applicationFocus';
import * as Styled from './styles';
import { elementContentType, sessionType } from '../../../../types';

const ValidatedInput = InputValidator(Input, { min: 0, max: 50 });

class SpacerSetting extends PureComponent {
    state = {
        blockIndex: null,
        columnIdx: null,
        elmIdx: null,
        content: null,
        contentValues: {
            height: 10,
            containerBackgroundColor: '#FF0000',
        },
        displayDividerColorPicker: false,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { dispatch, selectedElementData, applicationFocus } = nextProps;
        const { blockIndex, columnIdx, elmIdx, content } = selectedElementData;
        const { height, containerBackgroundColor } = content;
        const contentValues = { height, containerBackgroundColor };

        // give first element focus and reset
        if (applicationFocus === APPLICATION_FOCUS.RIGHT_PANEL) {
            dispatch(setApplicationFocus(APPLICATION_FOCUS.NONE));
        }

        const propsChanged =
            elmIdx !== prevState.elmIdx || JSON.stringify(contentValues) !== JSON.stringify(prevState.contentValues);
        if (propsChanged) {
            return { ...prevState, elmIdx, blockIndex, columnIdx, content, contentValues };
        }
        return { ...prevState };
    }

    _updateContent(key, value) {
        const { blockIndex, columnIdx, elmIdx, content, contentValues } = this.state;
        const { dispatch } = this.props;
        const newContentValues = { ...contentValues, [key]: value };
        const newContent = { ...content, ...newContentValues };
        dispatch(columnItemActions.updateColumnItemContent({ blockIndex, columnIdx, elmIdx, newContent }));
        this.setState((prevState) => ({
            ...prevState,
            contentValues: newContentValues,
        }));
    }

    render() {
        const { contentValues, displayDividerColorPicker } = this.state;
        const { height, containerBackgroundColor } = contentValues;
        const {
            session: { user, integration },
            applicationFocus,
        } = this.props;
        const {
            customization: { colors },
            features,
            isAdminOrParentAdmin,
        } = user;
        const brandColors = JSON.parse(colors).filter((item) => Object.prototype.hasOwnProperty.call(item, 'color'));
        const hasFullStylingAccess =
            features.EMAIL_DESIGNER_STYLING_ACCESS === undefined ? true : features.EMAIL_DESIGNER_STYLING_ACCESS;
        const hasCustomizationFeature = features.EMAIL_DESIGNER_CUSTOMIZATION;
        const hasCustomizationAccess = isAdminOrParentAdmin && (integration === 'LOCALHOST' || integration === 'APP');

        return (
            <div>
                <Styled.Row>
                    <HorizontalRule />
                    <Styled.Label>height</Styled.Label>
                    <ValidatedInput
                        type="number-small"
                        width={180}
                        icon="menu"
                        initialValue={height.toString()}
                        onChange={(event) => {
                            const value = +event.target.value;
                            if (value === height) {
                                return;
                            }
                            this._updateContent('height', value);
                        }}
                        onBlur={() => {
                            if (height < 1) {
                                this._updateContent('height', 1);
                            }
                        }}
                        isFocused={applicationFocus === APPLICATION_FOCUS.RIGHT_PANEL}
                    />
                    <Styled.Label>color</Styled.Label>
                    <Button
                        type="colorPicker"
                        width={180}
                        label="Color"
                        icon="format_color_fill"
                        shouldDisplayColorPicker={displayDividerColorPicker}
                        color={containerBackgroundColor}
                        presetColors={brandColors}
                        hasFullStylingAccess={hasFullStylingAccess}
                        hasCustomizationFeature={hasCustomizationFeature}
                        hasCustomizationAccess={hasCustomizationAccess}
                        value={containerBackgroundColor}
                        marginBottom="0"
                        onClick={() => this.setState({ displayDividerColorPicker: true })}
                        onChangeComplete={(color) => {
                            const { hex } = color;
                            this._updateContent('containerBackgroundColor', hex);
                        }}
                        onClose={() => this.setState({ displayDividerColorPicker: false })}
                        onChange={(event) => {
                            const { value } = event.target;
                            if (value.length > 20) {
                                return;
                            }
                            if (value[0] === '#' && value.length > 7) {
                                return;
                            }
                            this._updateContent('containerBackgroundColor', value);
                        }}
                    />
                </Styled.Row>
            </div>
        );
    }
}
const mapStateToProps = (state) => ({
    session: state.session,
    applicationFocus: state.browser.applicationFocus,
});

SpacerSetting.propTypes = {
    dispatch: PropTypes.func.isRequired,
    session: sessionType.isRequired,
    selectedElementData: elementContentType.isRequired,
    applicationFocus: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(SpacerSetting);
